// extracted by mini-css-extract-plugin
export default {"icon":"autocomplete_icon-module__icon--1KLq_"};